module.exports = __webpack_public_path__ + "vn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/vn.svg
// module id = 1138
// module chunks = 0